import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  wrapper: theme => css`
    display: flex;
    align-items: center;
    cursor: pointer;
    gap: ${theme.spacing.xxs};
    svg {
      background-color: ${theme.colors.neutral[100]}33;
      border-radius: ${theme.border.radius.full};
    }

    p {
      cursor: pointer;
      font-weight: ${theme.fontWeights.normal};
    }
  `,
})

export { useStyles }
